import { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function PublicLayout() {
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Top bar */}
      <header
        className="w-full"
        style={{ background: "var(--ldr-red)" }}
        data-testid="public-navbar"
      >
        <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center">
          {/* Desktop grid: left / center / right */}
          <div className="hidden md:grid grid-cols-3 items-center w-full">
            <div className="flex justify-start">
              <NavLink
                to="/reembolso"
                className={({ isActive }) => "nav-link" + (isActive ? " is-active" : "")}
                data-testid="nav-reembolso-link"
              >
                Pedir Reembolso
              </NavLink>
            </div>
            <div className="flex justify-center">
              <Link
                to="/"
                className="text-white font-bold uppercase tracking-[0.18em] text-lg"
                data-testid="nav-brand-link"
              >
                Lendas do Rock
              </Link>
            </div>
            <div className="flex justify-end">
              <NavLink
                to="/contactos"
                className={({ isActive }) => "nav-link" + (isActive ? " is-active" : "")}
                data-testid="nav-contactos-link"
              >
                Contactar
              </NavLink>
            </div>
          </div>

          {/* Mobile: hamburger left, brand center */}
          <div className="md:hidden flex items-center justify-between w-full">
            <button
              type="button"
              className="text-white p-2 -ml-2"
              onClick={() => setOpen((v) => !v)}
              aria-label="Abrir menu"
              data-testid="mobile-menu-toggle"
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
            <Link
              to="/"
              className="text-white font-bold uppercase tracking-[0.16em] text-base absolute left-1/2 -translate-x-1/2"
              data-testid="nav-brand-link-mobile"
            >
              Lendas do Rock
            </Link>
            <div className="w-8" />
          </div>
        </div>

        {/* Mobile drawer */}
        {open && (
          <div
            className="md:hidden mobile-drawer border-t border-black/30"
            data-testid="mobile-menu"
          >
            <div className="max-w-6xl mx-auto px-4 py-3 flex flex-col gap-1">
              <NavLink
                to="/reembolso"
                onClick={() => setOpen(false)}
                className={({ isActive }) => "mobile-drawer-link" + (isActive ? " is-active" : "")}
                data-testid="mobile-nav-reembolso"
              >
                Pedir Reembolso
              </NavLink>
              <NavLink
                to="/contactos"
                onClick={() => setOpen(false)}
                className={({ isActive }) => "mobile-drawer-link" + (isActive ? " is-active" : "")}
                data-testid="mobile-nav-contactos"
              >
                Contactar
              </NavLink>
            </div>
          </div>
        )}
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-[var(--ldr-border)] py-8 mt-16 bg-white">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-[var(--ldr-text-muted)]">
          <div className="font-semibold uppercase tracking-[0.16em] text-[var(--ldr-text)]">
            Lendas do Rock
          </div>
          <div className="flex gap-6">
            <Link to="/reembolso" className="hover:text-[var(--ldr-red)]">Pedir Reembolso</Link>
            <Link to="/contactos" className="hover:text-[var(--ldr-red)]">Contactar</Link>
          </div>
          <div>© {new Date().getFullYear()} Lendas do Rock</div>
        </div>
      </footer>
    </div>
  );
}
